<mat-expansion-panel
  class="info-panel remove-mat-expansion-panel-padding header-actions-panel"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
  [expanded]="panelOpenState">

  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="section-header-container">
        <p class="overline grey1 semibold section-title">{{sysText.assignedEmployers | uppercase}}</p>
        <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- beside the header, not inside it (the header is a button, so controls in it can't be used from the keyboard) -->
  <!-- edit keeps focus while its dialog loads: showProgress lays the spinner over its icon, disabledInteractive keeps it
  focusable, and the guard blocks clicks -->
  @let isLoading = isLoading$ | async;
  <div ngProjectAs="mat-expansion-panel-header" class="header-actions">
    @if (canEditEmployers) {
      <button
        mat-icon-button
        color="accent"
        class="edit-employee-button"
        [disabled]="isLoading"
        disabledInteractive
        [showProgress]="isLoading"
        [attr.aria-label]="isLoading ? sysText.loading_ariaLabel : sysText.edit_ariaLabel"
        (click)="!isLoading && editAssignedEmployers()">
        <mat-icon>edit</mat-icon>
        <mat-spinner progressIndicator diameter="24" color="accent"></mat-spinner>
      </button>
    }
  </div>

  <div class="main-content">
    <div class="item-container">
      <div class="item-label">
        <p class="body2 grey2">{{sysText.employers | titlecase}}</p>
      </div>
      @if (employers?.length > 0) {
        <div class="item-content body2 grey1 semibold">
          @for(er of employers; track er) {
            <div class="employer-line">
              <a class="link" [routerLink]="'/' + routes.EMPLOYER_PROFILE + '/' + er.id">
                {{ er.employerName }}
              </a>
              @if ((er | astype: assignedEmployerType).isDefault) {
                <app-status-chip
                  [icon]="(er | astype: assignedEmployerType).isMyDefault ? 'assignment_ind' : 'assignment_turned_in'"
                  [ngStyle]="(er | astype: assignedEmployerType).isMyDefault ? chipStyles.successBg : chipStyles.neutralBg"
                  [tooltip]="(er | astype: assignedEmployerType).isMyDefault ? sysText.isMyDefaultHint : sysText.editAssignedEmployers_default"
                  [removeMargin]="true">
                </app-status-chip>
              }
              @if ((er | astype: assignedEmployerType).isDefault && (er | astype: assignedEmployerType).defaultOverrideExists) {
                <app-status-chip
                  [icon]="'warning_amber'"
                  [ngStyle]="chipStyles.warnYelBg"
                  [tooltip]="sysText.assignedEmployers_defaultMessage"
                  [removeMargin]="true">
                </app-status-chip>
              }
            </div>
          }
        </div>
      } @else {
        <p class="body2 grey1 semibold">--</p>
      }
    </div>
  </div>
</mat-expansion-panel>